import { Injectable } from '@angular/core';
// import { BetDataService } from './betdata.service';
import { UserService } from './user.service';
import { ICustomNotification } from '../models/notification/customNotification';
import { TicketService } from './ticket.service';
import { NotificationService } from './notification.service';
import { ConstantValues } from '../models/util/constantValues';
import { DynamicTranslations } from '../../locale/dynamicTranslations';
import { DeployParams } from '../deployParams';
import { IPlayedTicket } from '../models/ticket/playedTicket';
import { TicketStatus, ErrorLevel, ErrorType, RequestSource, RESTServiceMessage } from '../models/enums';
import { ITicketItemTO } from '../models/ticket/transportObjects/ticketItemTO.interface';
import { ISellBetResponse } from '../models/ticket-validation/sellBetResponse.interface';
import { ISellBetRequest } from '../models/jacktime/transportObjects/sellBetRequestTO.interface';
import { LoaderService } from './loader.service';
import { Observable } from 'rxjs';
import { ITicket } from '../models/ticket/ticket.interface';
import { StorageService } from './util/storage.service';
import { ISellBetResponseTm } from '../models/ticket-validation/sellBetResponseTm.interface';
import { TicketManagerTicketService } from '../ticket-manager/services/ticket-manager-ticket.service';
import { environment } from 'src/environments/environment';

declare let jQuery: any;

@Injectable()
export class CashOutService {

  language: string;
  public statusEnum = TicketStatus;
  // public statusTranslations = DynamicTranslations.ticketAndOtherStatuses;
  public i = 1;
  currency = ConstantValues.CURRENCY;

  constructor(
    // private _dataService: BetDataService,
    private ticketService: TicketService,
    private notificationService: NotificationService,
    private ticketManagerService: TicketManagerTicketService,
    private userService: UserService,
    private loaderService: LoaderService,
    private storage: StorageService) {
    this.language = localStorage.getItem('languageId');
  }


  sellBet(ticket: IPlayedTicket = null, isAffilaite: boolean, pinCode?: string): void {
    // if (!ticket.blockedForSell) {
      this.loaderService.showHideLoader(true);
      let playerId: number;
      // if (environment.localDeploy) {
      //   playerId = DeployParams.LOCAL_USER_ID;
      // } else {
      // eslint-disable-next-line prefer-const
      playerId = +this.userService.user.userName;
      // }

      const ticketitems: Array<ITicketItemTO> = new Array<ITicketItemTO>();

      ticket.events.forEach(ev => {
        ev.outcomes.forEach(ti => {
        const ticketItem = {
          sportId: ev.sportId,
          regionId: ev.regionId,
          competitionId: ev.competitionId,
          eventID: ev.id,
          betId: ti.betId,
          betOutcomeId: ti.betOutcomeId
        };
        ticketitems.push(ticketItem as ITicketItemTO);
      });
    });


      const request: ISellBetRequest = {
        addToBalance: true,
        officeId: environment.betWebOfficeId,
        playerId,
        generatedTicketId: ticket.ticketNumber,
        refundValue: ticket.cashoutValue,
        source: RequestSource.Web,
        ticketId: ticket.id,
        ticketItems: ticketitems,
        pinCode
      };

      this.ticketService.sellBet(request, isAffilaite).subscribe((response: ISellBetResponseTm | ISellBetResponse) =>
        {
        if (isAffilaite) {
          this.processReplyTM(response as ISellBetResponseTm, ticket);
        } else {
          this.processReply(response as ISellBetResponse, ticket);
        }
        }, err => this.processNotification(err));
      this.i = 1;
    // }
  }

  processReplyTM(selBetResp: ISellBetResponseTm, ticket: IPlayedTicket) {
    const err: ICustomNotification = {
      message: '',
      title: '',
      offlineBets: [],
      restictedItems: [],
      errorLevel: ErrorLevel.Notification,
      errorType: ErrorType.Warning,
      ticket: null,
      link: null
    };

    if (!selBetResp.isSuccess) {
      err.title = DynamicTranslations.ticketValidation_title;
      err.message = selBetResp.failureReason;
      this.closeLoaderAndSendDataToDialog(err);
    } else {
      err.title = DynamicTranslations.ticketValidation_title;
      err.message = DynamicTranslations.cahseBackMessages_successOnSell;
      err.errorLevel = ErrorLevel.Success;
      err.errorType = ErrorType.CloseDialog;
      ticket.possibleMaxWin = ticket.cashoutValue;
      this.closeLoaderAndSendDataToDialog(err, ticket.id);

      this.ticketManagerService.changeCashOutTicketStatus(ticket.ticketNumber, selBetResp.data.amount);
    }
  }



  processReply(selBetResp: ISellBetResponse, ticket: IPlayedTicket) {

    const err: ICustomNotification = {
      message: '',
      title: '',
      offlineBets: [],
      restictedItems: [],
      errorLevel: ErrorLevel.Notification,
      errorType: ErrorType.Warning,
      ticket: null,
      link: null
    };

    if (!selBetResp.remoteOperationResult.success) {
      switch (selBetResp.remoteOperationResult.restServiceMessage) {
        case RESTServiceMessage.None:
          err.title = DynamicTranslations.ticketValidation_title;
          err.message = DynamicTranslations.cahseBackMessages_blockedForSell;
          this.closeLoaderAndSendDataToDialog(err);
          break;
        case RESTServiceMessage.PlatformError:
          err.title = DynamicTranslations.ticketValidation_title;
          err.message = selBetResp.remoteOperationResult.message;
          this.closeLoaderAndSendDataToDialog(err);
          break;
        case RESTServiceMessage.TicketNotInPendingState:
          err.title = err.title = DynamicTranslations.ticketValidation_title;
          err.message = DynamicTranslations.cahseBackMessages_mustBeInPendingState;
          this.closeLoaderAndSendDataToDialog(err);
          break;
        case RESTServiceMessage.AuthorizationTokenExpired:
          err.title = err.title = DynamicTranslations.ticketValidation_title;
          err.message = DynamicTranslations.cahseBackMessages_invalidUserToken;
          this.closeLoaderAndSendDataToDialog(err);
          break;
        case RESTServiceMessage.TicketNotFound:
          err.title = err.title = DynamicTranslations.ticketValidation_title;
          err.message = DynamicTranslations.cahseBackMessages_mustBeInPendingState;
          this.closeLoaderAndSendDataToDialog(err);
          break;
        case RESTServiceMessage.CashoutValueChanged:
          this.ticketService.getCasheoutValue(ticket.ticketNumber, ticket.createdBy).subscribe(x => {
            ticket.cashoutValue = x;
            err.errorType = ErrorType.CasheOutChange;
            err.title = err.title = DynamicTranslations.ticketValidation_title;
            err.message = DynamicTranslations.cahseBackMessages_casheBackValChangedTo + Math.round(ticket.cashoutValue * 100) / 100 + ' ' + this.currency;
            err.ticket = ticket;
            this.closeLoaderAndSendDataToDialog(err);
          });
          break;
        case RESTServiceMessage.EventOffline:
          err.title = err.title = DynamicTranslations.ticketValidation_title;
          err.message = DynamicTranslations.cahseBackMessages_OfflineEvents;
          this.closeLoaderAndSendDataToDialog(err);
          break;
        case RESTServiceMessage.PayoutNotAllowedForThatOffice:
          err.title = err.title = DynamicTranslations.ticketValidation_title;
          err.message = DynamicTranslations.cahseBackMessages_payoutNotAllowedOnOffice;
          this.closeLoaderAndSendDataToDialog(err);
          break;
        default:
          err.title = DynamicTranslations.ticketValidation_title;
          err.message = DynamicTranslations.ticketValidation_otherValidationProblem_ErrorMessage;
          this.closeLoaderAndSendDataToDialog(err);
          break;
      }

    } else {
      err.title = DynamicTranslations.ticketValidation_title;
      err.message = DynamicTranslations.cahseBackMessages_successOnSell;
      ticket.possibleMaxWin = ticket.cashoutValue;
      this.closeLoaderAndSendDataToDialog(err, ticket.id);
    }

  }

  updateCashOutValue(playedTicket: IPlayedTicket) {
    if (playedTicket.status.code === 11) {
      this.ticketService.getCasheoutValue(playedTicket.ticketNumber, playedTicket.createdBy).subscribe(payout => {
        if (payout) {
          playedTicket.cashoutValue = payout;
        }
      });
    }
  }

  updateCashOutValueTicket(ticket: ITicket) {
    if (ticket.statusId === 11) {
      this.ticketService.getCasheoutValue(ticket.ticketId, ticket.createdBy).subscribe(payout => {
        if (payout) {
          ticket.cashOutValue = payout;
        }
      });
    }
  }

  processNotification(arg0: any): void {
    this.loaderService.showHideLoader(false);
  }

  closeLoaderAndSendDataToDialog(err: ICustomNotification, cashbackedTicketId: number = null) {
    this.loaderService.showHideLoader(false);
    if (cashbackedTicketId) {
      this.notificationService.forwardDataToTicketDialog(null);
    }
    this.ticketService.reloadLastFiveTicketsOrUpdateTicket(cashbackedTicketId);
    this.notificationService.forwardDataToNotification(err);
  }

}
